<template>
  <div class="gooddess-container">
    <div v-if="loaded">
      <!-- 活动规则按钮跳转 -->
      <div class="rule-btn" @click="scrollRules">活动规则</div>
      <div class="lottery-container">
        <LotteryContainer
          ref="lottery"
          v-if="giftList.length"
          :list="giftList"
          :bgImg="homeBgUrl"
          :leftNum="lotteryNumber"
          :getUrl="lotteryUrl"
        />
      </div>
      <PaoMaDeng
        :delay="1"
        :speed="40"
        :content="winnerList"
        class="paomadeng"
        v-if="winnerList.length"
      >
        <div
          class="paomadeng-item"
          v-for="(item, index) in winnerList"
          :key="index"
        >
          <div class="avatar-container">
            <img class="item-avatar" :src="item.avatar" alt="" />
            <img
              class="item-active"
              v-if="item.prizeType == 10722796"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_icon"
            />
          </div>
          <div class="item-text">
            {{ item.truename + '刚刚获得了 ' + item.prizeName + 'x1' }}
          </div>
        </div>
      </PaoMaDeng>
      <!-- 抽奖按钮 -->
      <div
        class="lottery-btn"
        :class="{ 'lottery-btn-disabled': lotteryNumber <= 0 }"
        @click="bindLottery"
      >
        <div class="lottery-text">
          <span>立即抽奖</span>
          <span class="lottery-num">(剩余{{ lotteryNumber }}次)</span>
        </div>
      </div>
      <!-- 查看我的奖品 -->
      <div class="my-prize-box">
        <div class="my-prize-btn" @click="jumpMyPrize">查看我的奖品</div>
      </div>
      <!-- 奖品介绍 -->
      <div class="prize-introduce">
        <img
          class="introduce-title"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_prize_introduce_title"
          alt=""
        />
        <img
          class="introduce-item"
          v-for="(item, index) in prizeIntroduce"
          :key="index"
          :src="item"
          alt=""
        />
      </div>
      <!-- 活动规则 -->
      <div class="active-rules" ref="rules">
        <img
          class="rules-title"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_rule_title"
          alt=""
        />
        <img
          class="rules-item"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_rules"
          alt=""
        />
        <!-- 复制微信号按钮 -->
        <div
          class="copy-btn"
          ref="copy"
          :data-clipboard-text="wechatCode"
          @click.stop="copyWechat"
        ></div>
      </div>
      <!-- logo -->
      <div class="logo-container">
        <img
          class="logo-item"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/24da8650c5efff164cc4fb70e8d11805.png"
          alt=""
        />
        <div class="line"></div>
        <img
          class="logo-item"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/pub-jzy-logo"
          alt=""
        />
      </div>
      <!-- 底部固定栏 -->
      <div class="bottom-fixed-container">
        <div class="btn-item not-start" v-if="activeStatus == 0">
          活动未开始
        </div>
        <template v-if="activeStatus == 1">
          <div class="btn-item left-btn" @click="jumpMyPrize">我的奖品</div>
          <div
            class="btn-item right-btn"
            :class="{ 'right-btn-disabled': lotteryNumber <= 0 }"
            @click="bindLottery"
          >
            <span>立即抽奖</span>
            <span class="right-text"
              >剩余<span class="number">{{ lotteryNumber }}</span
              >次</span
            >
          </div>
        </template>
        <div class="btn-item end" v-if="activeStatus == 2">活动已结束</div>
      </div>
    </div>
    <!-- 加载 -->
    <van-loading
      v-if="!loaded"
      class="loading"
      type="spinner"
      color="#f96d91"
    />
  </div>
</template>
<script>
import Clipboard from 'clipboard'
import LotteryContainer from '@/components/lottery/index'
import PaoMaDeng from './ponents/paomadeng'
import { prizeIntroduce } from './data.js'
export default {
  components: { LotteryContainer, PaoMaDeng },
  data() {
    return {
      loaded: false, //是否加载完成
      lotterying: false, //是否正在请求抽奖
      homeBgUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_lottery_turntable',
      prizeIntroduce,
      lotteryUrl: 'member/ActivityGirl/draw',
      giftList: [],
      lotteryNumber: 1, //抽奖次数
      activeStatus: 0,
      winnerList: [],
      wechatCode: 'gymer18', // 微信客服号
      clipboard: null
    }
  },
  created() {
    this.init()
    this.addLog()
  },
  mounted() {},
  methods: {
    //新版数据统计
    addLog() {
      let data = {
        from: '2022年女神节banner和弹窗点击量',
        type: 3
      }
      this.$http
        .postApp('member/StorageLogin/spotLog', data)
        .then((res) => {})
        .catch((err) => {})
    },
    //复制微信号
    copyWechat() {
      this.clipboard.on('success', () => {
        this.$toast.success('复制成功')
      })
      this.clipboard.on('error', () => {
        this.$toast.fail('复制失败，请手动复制')
      })
    },
    init() {
      this.$http
        .getApp('member/ActivityGirl/drawInit', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.lotteryNumber = res.data.lotteryNumber
            this.activeStatus = res.data.activeStatus
            this.giftList = res.data.giftList
            this.winnerList = res.data.winnerList
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast(err.message)
        })
        .finally(() => {
          this.loaded = true
          this.$nextTick(() => {
            console.log(this.$refs.copy)
            this.clipboard = new Clipboard(this.$refs.copy)
          })
        })
    },
    //跳转到我的奖品
    jumpMyPrize() {
      this.$router.push('/goddess-festival-prize')
    },
    scrollRules() {
      console.dir(this.$refs.rules)
      this.$refs.rules.scrollIntoView()
    },
    //点击抽奖
    bindLottery() {
      let isMove = this.$refs.lottery.isMove()
      console.log(isMove)
      if (isMove) {
        return
      }
      this.getAward()
    },
    //抽奖请求接口
    getAward() {
      if (this.lotterying) {
        return
      }
      this.lotterying = true
      this.$http
        .getApp(this.lotteryUrl, {})
        .then((res) => {
          res = res.data
          /*  res = {
            code:200,
            data:{
              index:4
            },
          }; */
          if (res.code == 200) {
            let id = res.data.index
            this.lotteryNumber = this.lotteryNumber - 1
            this.$refs.lottery.success(id)
            this.init()
          } else {
            this.$dialog
              .alert({
                title: '提示',
                message: res.msg,
                theme: 'round-button',
                confirmButtonText: '好的'
              })
              .then(() => {
                // on close
              })
            this.$refs.lottery.fail()
          }
        })
        .catch((err) => {
          console.log(err)
          this.$toast(err.message)
          this.$refs.lottery.fail()
        })
        .finally(() => {
          this.lotterying = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.gooddess-container {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2022_goddess_festival_home_bg');
  background-size: contain;
  background-position: center top;
  background-repeat: no-repeat;
  background-color: #fed7ed;
  padding-bottom: 48px;
}
.rule-btn {
  position: fixed;
  right: 0;
  top: 86px;
  width: 32px;
  display: flex;
  text-align: center;
  background: #fff;
  border-radius: 8px 0px 0px 8px;
  color: #9a57fe;
  padding: 8px;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 15px;
  z-index: 1;
}
.lottery-container {
  margin-top: 458px;
  margin-bottom: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lottery-btn {
  text-align: center;
  width: 335px;
  margin: 0 auto 20px;
  height: 44px;
  background: linear-gradient(180deg, #9a57fe 0%, #6d48e3 100%);
  box-shadow: 0px 4px 7px 0px rgba(113, 50, 226, 0.2);
  border-radius: 13px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
}
.lottery-btn-disabled {
  opacity: 0.43;
}
.lottery-text {
  display: inline-block;
  position: relative;
}
.lottery-num {
  position: absolute;
  left: 110%;
  top: 50%;
  white-space: nowrap;
  transform: translate(0%, -50%);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
}
.paomadeng {
  margin-bottom: 16px;
}
.paomadeng-item {
  display: flex;
  align-items: center;
  margin-right: 8px;
  height: 40px;
  background: rgba(255, 255, 255, 0.59);
  padding: 4px 5px;
  box-sizing: border-box;
  border-radius: 21px;
  .avatar-container {
    position: relative;
  }
  .item-active {
    width: 27px;
    height: 27px;
    position: absolute;
    left: 40%;
    bottom: 50%;
    z-index: 1;
  }
  .item-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    object-fit: contain;
  }
  .item-text {
    white-space: nowrap;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 18px;
  }
}
.my-prize-box {
  text-align: center;
  margin-bottom: 24px;
}
.my-prize-btn {
  display: inline-block;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #524b6d;
  line-height: 21px;
  text-decoration: underline;
}
.prize-introduce {
  padding: 0px 15px;
  margin-bottom: 26px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  .introduce-title {
    width: 198px;
    margin-bottom: 12px;
  }
  .introduce-item {
    width: 100%;
    height: auto;
    margin-bottom: 12px;
  }
  .introduce-item:last-child {
    margin-bottom: 0px;
  }
}
.active-rules {
  padding: 0px 15px;
  margin-bottom: 26px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  .rules-title {
    width: 198px;
    margin-bottom: 12px;
  }
  .rules-item {
    width: 100%;
    height: auto;
  }
  .copy-btn {
    width: 100px;
    height: 30px;
    position: absolute;
    bottom: 27px;
    right: 43px;
  }
}
.bottom-fixed-container {
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 1;
  .btn-item {
    flex: 1;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .right-btn {
    background: #765adc;
  }
  .right-btn-disabled {
    background: rgb(204, 158, 240);
  }
  .right-text {
    margin-left: 9px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .end {
    background: rgba(78, 78, 78, 0.95);
  }
  .not-start {
    background: rgba(78, 78, 78, 0.95);
  }
  .left-btn {
    background: #f96d91;
  }
  .number {
    color: #ffe48c;
  }
  .btn-center {
    display: inline-block;
    position: relative;
  }
}
.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 31px;
  .logo-item {
    width: auto;
    height: 27px;
  }
  .line {
    width: 1px;
    height: 27px;
    background: rgba(0, 0, 0, 0.24);
    margin: 0px 10px;
  }
}
.loading {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
